import { yup } from 'common/validation/initYup';

export const DocumentSendToProtocolQueueSchema = yup.object({
  subject: yup.string().required().label('Oggetto'),
  mode: yup.string().required().label('Modalità di Protocollo'),
  registryId: yup.number().required().label('Registro'),
  document: yup.object().required().label('Documento Principale')
});
